<template>
  <div class="addList">
    <div class="addListTit">
      <span>申请材料</span>
      <el-checkbox
        :indeterminate="isIndeterminate"
        v-model="checkAll"
        @change="meterialCheckAllChange">全选</el-checkbox>
    </div>
    <div
      class="addListCb"
      id="task_list_check">
      <ul>
        <el-checkbox-group
          v-model="checkedMeterial"
          @change="meterialCheckedChange">
          <li
            v-for="item in cloudDiskData"
            :key="item">
            <el-checkbox :label="item"> {{ item.file_name }}</el-checkbox>
          </li>
        </el-checkbox-group>
      </ul>
    </div>
    <div class="addListFot">
      <el-button
        type="primary"
        size="small"
        :disabled="checkedMeterial.length === 0"
        @click="meterialSave">保存</el-button>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    cloudDiskData: {
      type: Array,
      default() {
        return {};
      },
    },
    uploadData: {
      type: Object,
      default() {
        return {};
      }
    },
    uploadPosition: {
      type: Object,
      default() {
        return {};
      },
    }
  },
  data() {
    return {
      checkAll: false, // 默认全选按钮是否选中
      checkedMeterial: [], // 设置默认选中
      isIndeterminate: false, // 表示checkbox的不确定状态，一般用于实现全选的效果
    };
  },
  mounted() {
  },
  methods: {
    /*
       * 初始化数据
       * */
    getDiskInfo(id) {
      this.$emit('loading-refresh', true);
      this.$http._post({
        url: `/index/student/cloudDisk/userid/${id}`
      }).then((response) => {
        this.$emit('loading-refresh', false);
        this.$emit('refresh-cloud-data', response.data);
        this.$message.success('保存成功');
      }).catch(() => {

      });
    },
    /*
       * 全选操作
       * */
    meterialCheckAllChange(val) {
      this.checkedMeterial = val ? this.cloudDiskData : [];
      this.isIndeterminate = false;
    },
    /*
       * 单选操作
       * */
    meterialCheckedChange(value) {
      this.checkedMeterial = value;
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cloudDiskData.length;
      this.isIndeterminate = checkedCount > 0 &&
          checkedCount < this.cloudDiskData.length;
    },
    /*
       * 材料保存
       * */
    meterialSave() {
      let ids = [];
      let data1 = {};
      this.checkedMeterial.forEach((item) => {
        ids.push(item.id);
      });
      Object.assign(data1, this.uploadPosition, this.uploadData, { add: 1, upload_type: ids });
      this.$http._post({
        url: '/index/apply_file/setUploadType/',
        data: data1,
      }).then(() => {
        this.$message.success('保存成功');
        this.$emit('dialog-disk-visible', { isdialog: false });
      }).catch(() => {
        this.$message.error('保存失败');
      });
    },
    /*
       * 清空 关闭数组
       * */
    closeMeterial() {
      this.checkedMeterial = [];
      this.isIndeterminate = false;
      this.checkAll = false;
    },

  },
};
</script>
<style src="../../assets/css/common-pc.css"></style>
<style>
  .addList {
    background-color:#fff;
    position:relative;
  }
  .addList h3 {
    color:#3368fa;
    font-size:18px;
    margin:0
  }
  .addListTit {
    width:100%;
    height:35px;
    line-height:35px;
    background-color:#c7d1da;
    font-size:14px;
    font-weight:bold;
    color:#575757;
    border:1px solid #d1d6d9
  }
  .addListTit span{
    margin-left:5px
  }
  .addListTit input[type='checkbox']{
    float:left;
    margin-top:12px;
    margin-left:15px
  }
  .addListCb{
    width:100%;
    height:auto;
    overflow:hidden
  }
  .addListCb ul{
    overflow:hidden;
    border-left:1px solid #d1d6d9
  }
  .addListCb ul li {
    width: 33.3333%;
    float:left;
    padding-left: 10px;
    height:30px;
    line-height:30px;
    color:#6a6a6a;
    font-size:14px;
    border-right:1px solid #d1d6d9;
    border-bottom:1px solid #d1d6d9
  }
  .addListCb ul li input[type='checkbox']{
    float:left;
    margin-top:10px
  }
  .addListCb ul li span {
    display: inline-block;
    vertical-align: middle;
    overflow:hidden;
    max-width:200px;
    white-space:nowrap;
    text-overflow:ellipsis
  }
  .addListCb ul li span:last-child{
    padding-right:10px;
  }
  .addListFot {
    margin-top:20px;
  }

</style>
